import axios from 'axios'
import { ElMessage } from "element-plus"
import { getToken, removeToken } from './auth'
import qs from 'qs'
import {
	useStore
} from 'vuex'

const store = useStore();


let baseURL = ''

// 创建axios实例
const service = axios.create({
	baseURL: baseURL,
	timeout: 120000
})

/**
 * @desc: 异常拦截处理器
 * @param { Object } error 错误信息
 */
let errorTimeOut = null;
const errorHandler = (error) => {

	if (error.response.data.errorCode == "999") {
		if (errorTimeOut) {
			clearTimeout(errorTimeOut)
		}
		errorTimeOut = setTimeout(() => {
			ElMessage.error(error.response.data.message);
			setTimeout(() => {
				removeToken();
				if (store) {
					store.dispatch("LogOut");
				} else {
					window.location.href = '#/login';
				}
			}, 300)
		}, 300)

	} else {
		try {
			const response = error.response
			if (response && response.status) {
				if (response.status == 502) {
					ElMessage.error('服务器正在重启中，请稍后再试！')
					return Promise.reject(error.response.data)
				}
				if (response.status == 404) {
					ElMessage.error('请求地址不存在！')
					return Promise.reject(error.response.data)
				}
			}
			if (error.response && error.response.data.msg) {
				ElMessage.error(error.response.data.msg)
			} else {
				if (error.meta && error.meta.message) {
					ElMessage.error(error.meta.message)
				} else {
					ElMessage.error(error.response.data.meta.message)
				}
			}
			return Promise.reject(error.response.data)
		} catch (e) {
			// alert('超时')
			return Promise.reject(error);
		}
	}
	return Promise.reject(error.response.data)
}

/**
 * @desc: 请求发送前拦截
 * @param { Object } config 配置参数
 */
service.interceptors.request.use(config => {
	config.headers['Authorization'] = getToken()
	if (config.method === 'formdata') {
		config.method = 'post';
		config.data = qs.stringify(config.data);
		config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
	}
	return config
}, errorHandler)


/**
 * @desc: 服务端响应后拦截
 * @param { Object } response 返回的数据
 */
service.interceptors.response.use(res => {
	res = res.data;
	
	if (res.success) {
		if (res.data) {
			return res.data
		} else {
			return res;
		}

	} else {
		if (res.status == 1) {
			return res;
		}
		if(res.rows &&  res.rows.respCode == "0000"){
			return res;
		};
		if(res.rspBody &&  res.retCode == "0000000"){
			return res;
		}
		if (res.code == 0) {
			return res;
		}
		if (res.status == 0) {
			let data0 = res.data.data_0;
			return data0 || res.data;
		} else if (res.status == -1) {
			// return res.data;
			ElMessage.error(res.msg)
			return Promise.reject(res);
		} else if (res.code == '200') {
			return res.data;
		} else {
			return Promise.reject(res);
		}
	}	// 2xx 范围内的状态码都会触发该函数, 否则进入errorHandler

}, errorHandler)

export default service
